import React,{useState, useEffect} from 'react';
import { isOpenMultiLevelProduct,isShowProductDetailSource, getPublicOrPrivate,requestOrgPropertySetting } from './orgProperties'

// 多级产品开关状态,true/false
export const useMultipleProductsSwitch = () => {
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    isOpenMultiLevelProduct().then((flag = false) => {
      setFlag(flag)
    })
  },[])
  return flag;
}
/**
 * 是否展示平台产品的详细来源？
 * @returns true:展示
 */
export const useShowProductDetailSource = () => {
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    isShowProductDetailSource().then((flag = false) => {
      setFlag(flag)
    })
  },[])
  return flag;
}
// 获取对公对私属性. 1-对公 2-对私
export const usePublicOrPrivate = () => {
  const [flag, setFlag] = useState('');
  useEffect(() => {
    getPublicOrPrivate().then((flag = '') => {
      setFlag(flag)
    })
  },[])
  return flag;
}
// 查询所有开关
export const useOrgPropertySetting = () => {
  const [properties, setProperties] = useState({});
  useEffect(() => {
    requestOrgPropertySetting().then((properties = {}) => {
      setProperties(properties)
    })
  },[])
  return properties;
}